export const inr = (n) => "₹" + (n || 0).toLocaleString("en-IN");
export const rating = (id) => 3.9 + ((id.charCodeAt(0) + id.charCodeAt(id.length - 1)) % 11) / 10;
export const reviews = (id) => 12 + (id.charCodeAt(1) % 88);

export function shade(hex, percent) {
  try {
    const n = parseInt(hex.slice(1), 16);
    let r = (n >> 16) + Math.round(2.55 * percent);
    let g = ((n >> 8) & 0xff) + Math.round(2.55 * percent);
    let b = (n & 0xff) + Math.round(2.55 * percent);
    r = Math.max(0, Math.min(255, r)); g = Math.max(0, Math.min(255, g)); b = Math.max(0, Math.min(255, b));
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  } catch { return hex; }
}
export function hexA(hex, a) {
  try {
    const n = parseInt(hex.slice(1), 16);
    return `rgba(${n >> 16}, ${(n >> 8) & 0xff}, ${n & 0xff}, ${a})`;
  } catch { return hex; }
}
